import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';

import { AuthService } from '../../services/auth/auth.service';
import { openLoginDialog } from '../../services/auth/login-dialog.util';

/**
 * Exige sessão ativa. Sem login, leva para a home pública e abre o modal de
 * login guardando o destino (evita renderizar/vazar a página protegida).
 */
export const authGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  if (inject(AuthService).isLogged()) {
    return true;
  }

  openLoginDialog(inject(DialogService), state.url);
  return inject(Router).parseUrl('/home');
};
